module.exports = __webpack_public_path__ + "img/logo-full-white.141a2972.svg";